import { ActivatedRoute } from '@angular/router';

export const getChildRoute = (activatedRoute: ActivatedRoute): ActivatedRoute => (activatedRoute.firstChild ? getChildRoute(activatedRoute.firstChild) : activatedRoute);
